import axios from "axios";
import moment from "moment";

// raw ajax call based on axios
export function ajax(url, data = {}, options = {}) {
  const defaults = {
    method: "get", // get / post etc
    url: url,
    data: data,
    dataOnly: false, //just return the data
    stripD: false, //remove the d wrapper that asp adds
    queryStringForGet: false, //send data as qry strng when using get
    parseAspDates: false, //automaticaly parse asp.net dates ("/Date(1198908717056)/")
  };

  const settings = Object.assign({}, defaults, options);

  // generate query string params for get request
  if (settings.method.toLowerCase() === "get" && settings.queryStringForGet) {
    settings.params = settings.data;
    settings.paramsSerializer = function (params) {
      // just serialize each param to JSON (unless string else adds extra "")
      return Object.keys(params)
        .map(function (key) {
          let value = params[key];
          if (typeof value !== "string") {
            value = JSON.stringify(value);
          }
          return `${key}=${value}`;
        })
        .join("&");
    };
  }

  settings.transformResponse = [];

  // parseAspDates
  if (settings.parseAspDates) {
    settings.transformResponse.push(function (data) {
      return JSON.parse(data, function (key, value) {
        //check for ASP style date formating
        var regex = /\/Date\(.*\)\//i;
        if (typeof value === "string" && regex.test(value)) {
          return moment(value).toDate();
        }
        return value;
      });
    });
  } else {
    //otherwise just parse JSON
    settings.transformResponse.push(JSON.parse);
  }

  //remove the d wrapper that asp adds
  if (settings.stripD) {
    settings.transformResponse.push((data) => data.d);
  }

  //TODO caching?

  return axios(settings).then(function (obj) {
    //just return the data
    return settings.dataOnly ? obj.data : obj;
  });
}

export function websiteService(func, data = {}, options = {}) {
  const defaults = {
    method: "get",
    queryStringForGet: true,
    parseAspDates: true,
    stripD: true,
    dataOnly: true,
  };
  const settings = Object.assign({}, defaults, options);
  const url = `/WebsiteService.svc/${func}`;
  return ajax(url, data, settings);
}

export function pageService(func, data = {}, options = {}) {
  const defaults = {
    method: "post",
    page: window.location.pathname, //can be changed to target another page
    parseAspDates: true,
    stripD: true,
    dataOnly: true,
  };
  const settings = Object.assign({}, defaults, options);
  const url = `${settings.page}/${func}`;
  return ajax(url, data, settings);
}
